import Url from 'url';
import {pushEdapEvent} from '../utils/edap';
import {createSerpLink} from '../utils/serp';
import {UPDATE_SEARCH} from './action-types';
import {UNREFINED_KEY} from './listings';

export function setSearchData(payload) {
    return {type: UPDATE_SEARCH, payload};
}

export function redirect(url) {
    return {type: 'REDIRECT', url};
}

export function setRefinements(refinements) {
    return {
        type: 'RECEIVE_REFINEMENTS',
        refinements
    };
}

export function setKeywords(keywords) {
    return {
        type: 'RECEIVE_KEYWORDS',
        keywords
    };
}

export function setSerpUrlDomain(domain) {
    return {
        type: 'RECEIVE_SERP_URL_DOMAIN',
        domain
    };
}

export function showDatesPopup(propertyName, tripleId, listingUri, location) {
    return {
        type: 'SHOW_DATES_POPUP',
        propertyName,
        tripleId,
        listingUri,
        location
    };
}

export function hideDatesPopup() {
    return {
        type: 'HIDE_DATES_POPUP'
    };
}

export function setArrivalDate(date) {
    return {
        type: 'RECEIVE_ARRIVAL_DATE',
        date
    };
}

export function setDepartureDate(date) {
    return {
        type: 'RECEIVE_DEPARTURE_DATE',
        date
    };
}

/**
 * Push to EDAP.
 * @param {String} event - event name
 * @param {Object} eventOptions - event options
 * @param {Object} edapOptions - edap options
 * @returns {void}
 */

function reportDatedSearchSubmit(arrivalDate, departureDate, actionLocation) {
    pushEdapEvent(
        'dated.search.submit',
        {
            startdate: arrivalDate,
            enddate: departureDate,
            actionlocation: actionLocation
        },
        {
            delayProcessing: true
        }
    );
}

function reportSearchSubmit(actionLocation, eventrefinements) {
    const isButton =
    ['properties-map-module', 'properties-module'].indexOf(actionLocation) !==
    -1;

    let edapEventName;
    let adls = {
        actionlocation: actionLocation
    };

    if (isButton) {
        edapEventName = 'search.link.click';
        adls.eventrefinements = eventrefinements;
    } else {
        edapEventName = 'search.submit';
    }

    pushEdapEvent(edapEventName, adls, {
        delayProcessing: true
    });
}

function reportDatedPdp(arrivalDate, departureDate) {
    pushEdapEvent(
        'generic.event',
        {
            eventcategory: 'datedpdp',
            eventaction: 'view',
            startdate: arrivalDate,
            enddate: departureDate
        },
        {
            delayProcessing: true
        }
    );
}

export function goToSerp(options = {}) {
    const {
        datedSearchSubmit = false,
        actionLocation = null,
        eventrefinements = '',
        searchLink = false,
        refinementKey = UNREFINED_KEY,
        serpUrlFilters = {}
    } = options;

    return (dispatch, getState) => {
        const state = getState();

        const {
            search: {arrivalDate, departureDate, serpUrl, datedSerpUrl}
        } = state;

        const url = datedSearchSubmit ? datedSerpUrl : serpUrl;

        if (datedSearchSubmit) {
            reportDatedSearchSubmit(arrivalDate, departureDate, actionLocation);
        }

        if (searchLink) {
            reportSearchSubmit(actionLocation, eventrefinements);
        }

        if (refinementKey !== UNREFINED_KEY) {
            const filterUrl = serpUrlFilters[refinementKey] || '';
            dispatch(redirect(`${url}${filterUrl}`));
            return;
        }
        dispatch(redirect(url));
    };
}

export function goToPinnedSerp(options = {}) {
    const {
        datedSearchSubmit = false
    } = options;

    return (dispatch, getState) => {
        const state = getState();

        const {
            search: {serpUrl, datedSerpUrl, tripleId}
        } = state;

        const data = {
            'pinnedPropertyListing': tripleId,
            'channel': 'slp'
        };

        const url = datedSearchSubmit ? createSerpLink(datedSerpUrl, data)
            : createSerpLink(serpUrl, data);

        dispatch(redirect(url));
    };
}

function pad(s) {
    return s < 10 ? `0${s}` : s;
}

function convertDate(yyyymmdd) {
    const [year, month, day] = yyyymmdd.split('-').map((x) => +x); // Convert to numbers
    const date = new Date(year, month - 1, day);
    return [
        pad(date.getMonth() + 1),
        pad(date.getDate()),
        date.getFullYear()
    ].join('/');
}

function calculatePdpUrl(uri, arrivalDate, departureDate) {
    let listingUrlOptions = Url.parse(`https://${uri}`, true);
    delete listingUrlOptions.path;
    delete listingUrlOptions.search;
    listingUrlOptions.query = Object.assign(listingUrlOptions.query || {}, {
        arrivalDate: convertDate(arrivalDate),
        departureDate: convertDate(departureDate)
    });
    return Url.format(listingUrlOptions);
}

export function goToPdp(listing, options = {}) {
    const {datedPdpSubmit = false} = options;

    return (dispatch, getState) => {
        const state = getState();
        const {search: {arrivalDate, departureDate}} = state;

        if (!listing) {
            throw new Error('A listing object should be passed as first parameter');
        }

        if (datedPdpSubmit && arrivalDate && departureDate) {
            reportDatedPdp(arrivalDate, departureDate);

            const pdpUrl = calculatePdpUrl(
                listing.listingUri,
                arrivalDate,
                departureDate
            );

            dispatch(redirect(pdpUrl));
        } else {
            dispatch(redirect(`https://${listing.listingUri}`));
        }
    };
}
